class RestockNotification extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    this.form = this.querySelector('[data-restock-form]');
    this.status = this.querySelector('[data-restock-status]');
    this.success = this.querySelector('[data-restock-success]');
    this.productForm = document.forms[this.dataset.productFormId];
    this.form?.addEventListener('submit', (event) => this.subscribe(event), {
      signal: this.abortController.signal,
    });
    this.productForm?.addEventListener('variant:change', (event) => this.updateVariant(event.detail.variant), {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  updateVariant(variant) {
    this.status.textContent = '';
    this.status.hidden = true;

    if (!variant?.id) {
      this.hidden = true;
      delete this.dataset.variantId;
      delete this.dataset.variantTitle;
      return;
    }

    const variantId = String(variant.id);
    const numericVariantId = variantId.replace('gid://shopify/ProductVariant/', '');
    const productUrl = new URL(this.dataset.productUrl);

    productUrl.searchParams.set('variant', numericVariantId);
    this.dataset.variantId = variantId.startsWith('gid://shopify/ProductVariant/')
      ? variantId
      : `gid://shopify/ProductVariant/${variantId}`;
    this.dataset.variantTitle = variant.title;
    this.dataset.productUrl = productUrl.toString();
    this.hidden = Boolean(variant.available);
  }

  async subscribe(event) {
    event.preventDefault();

    if (this.hidden || !this.dataset.variantId) return;

    const button = this.form.querySelector('button[type="submit"]');
    const formData = new FormData(this.form);
    const payload = {
      email: formData.get('email'),
      company: formData.get('company'),
      product_id: this.dataset.productId,
      variant_id: this.dataset.variantId,
      product_title: this.dataset.productTitle,
      variant_title: this.dataset.variantTitle,
      product_url: this.dataset.productUrl,
    };

    button.disabled = true;
    this.status.hidden = true;

    try {
      const response = await fetch(this.form.action, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json().catch(() => ({}));

      if (!response.ok) throw new Error(result.message || this.dataset.errorMessage);

      this.form.reset();
      this.status.textContent = this.success.content.textContent.trim();
      this.status.hidden = false;
    } catch (error) {
      this.status.textContent = error.message || this.dataset.errorMessage;
      this.status.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('restock-notification')) {
  customElements.define('restock-notification', RestockNotification);
}
